import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {DialogModel} from '../../../../core/models';

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.css']
})
export class SuccessDialogComponent implements OnInit {
  jobId: string;
  dialogData: DialogModel;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<SuccessDialogComponent>) { }

  ngOnInit() {
    this.dialogData = this.data.dialogData;
    this.jobId = this.data.jobId;
  }

  close() {
    this.dialogRef.close();
  }
  viewJob() {
  window.open(`/job/${this.jobId}`, '_blank');
}
}
